<template>
  <div>
    <SpellFeeTieredTable
      ref="table"
      :disabled="disabled"
      :tableData="formData.spellFeeTieredList"
    />
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">保存</el-button>
    </div>
  </div>
</template>
<script>
import SpellFeeTieredTable from './spellfee-tiered-table.vue'
export default {
  components: {
    SpellFeeTieredTable,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    contractCarrierCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        contractCode: '',
        spellFeeTieredList: [],
      },
    }
  },
  watch: {
    contractCarrierCode: {
      handler(contractCarrierCode) {
        if (contractCarrierCode || contractCarrierCode !== '') {
          this.loadDetail()
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadDetail() {
      if (!this.contractCarrierCode) return
      this.$api
        .contractCarrierSpellfeeDetailApi({
          contractCode: this.contractCarrierCode,
        })
        .then((res) => {
          this.formData.spellFeeTieredList = res.body.data
        })
    },

    async save() {
      const tableData = await this.$refs.table.getTableData()
      // if (!tableData || !tableData.length) {
      //   this.$message.warning('请添加拼点费信息')
      //   return Promise.reject()
      // }
      const validResult = await this.$refs.table.validEvent()
      if (!validResult) return Promise.reject()

      this.formData.spellFeeTieredList = tableData
      this.formData.contractCode = this.contractCarrierCode

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .contractCarrierSpellfeeSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          const { status, msg } = res
          this.$message({
            type: status === 200 ? 'success' : 'error',
            message: msg,
          })
          this.loadDetail()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
